export default __webpack_public_path__ + "static/media/052.90e58f77.jpg";